import React from 'react';
import { Card, Steps, Button, Dropdown, Menu, Modal } from 'antd';
import ExpressForm from './expressForm';
import CheckForm from './checkForm';
import ContactForm from './contactForm';
import PackageList from './packageList';
import { expressDescSteps, expressStatusMap } from './enums.js';
import { getExpressMaterialInfo, getExpressPackageList, createExpressMaterialTask, approveExpressMaterialCheck, finishExpressMaterial, addExpressPackage } from '../../../../service/expressMaterial';
import './style.scss';

const { Step } = Steps;


// 根据邮寄任务状态获取当前邮寄是在第几步
const getStepByStatus = status => expressStatusMap.flat().includes(status) ? expressStatusMap.findIndex(statusList => statusList.includes(status)) : 0

// 材料邮寄
export default class MaterialExpress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flowId: props.flowId,
      currentStep: 0,
      rejectCheckVisible: false,
      contactVisible: false,
      expressVisible: false,
      handleLoading: false,
      recheckLoading: false,
      postLoading: false,
      // 已收到的包裹列表
      receivedPackageList: [],
      // 已寄出的包裹列表
      postedPackageList: [],
      expressResult: { state: '', records: {} },
      // 区分邮寄弹框类型, 空-已邮寄, receive-收到, post-寄出
      expressType: ''
    }
  }

  componentDidMount() {
    this.getExpressInfo();
    this.getReceivedPackages();
    this.getPostedPackages();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.flowId !== state.flowId) {
      return {
        flowId: props.flowId
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.flowId && prevProps.flowId !== this.props.flowId) {
      this.getExpressInfo();
      this.getReceivedPackages();
      this.getPostedPackages();
    }
  }

  // 获取审核材料详情
  getExpressInfo = async () => {
    try {
      const { result } = await getExpressMaterialInfo({
        flowId: this.state.flowId
      })
      this.setState({
        expressResult: result
      })
    } catch (err) {
      console.log(err)
    }
  }
  getReceivedPackages = async () => {
    const { flowId } = this.state;
    try {
      const { result } = await getExpressPackageList('receive', { flowId });
      this.setState({
        receivedPackageList: result
      })
    } catch {}
  }
  getPostedPackages = async () => {
    const { flowId } = this.state;
    try {
      const { result } = await getExpressPackageList('post', { flowId })
      this.setState({
        postedPackageList: result
      })
    } catch {}
  }
  // 发起邮寄任务
  handleExpressTask = async () => {
    this.setState({
      handleLoading: true
    })
    try {
      const { result } = await createExpressMaterialTask(this.state.flowId, {
        content: expressDescSteps.toCheck
      });
      this.setState({
        expressResult: result
      })
    } catch { }
    this.setState({
      handleLoading: false
    })
  }

  // 初审通过
  handleApprove = async () => {
    try {
      const { result } = await approveExpressMaterialCheck(this.state.flowId, {
        content: '审核通过，理赔员可进行已定损操作。'
      })
      this.setState({
        expressResult: result
      })
    } catch { }
  }

  onShowExpress = (expressType = '') => {
    this.setState({
      expressVisible: true,
      expressType
    })
  }
  // 根据不同的状态，渲染操作记录
  renderRecords = (status) => {
    const { records = {} } = this.state.expressResult, list = records[status] || [];
    return list.map((item, index) => <dl key={index}>
      <dt>{item.content}</dt>
      <dd><span className="handle-name">处理人：{item.agentName}</span>时间：{item.time}</dd>
    </dl>)
  }

  // 联系客户,邮寄信息,退回  成功回调
  onSuccess = result => {
    this.setState({
      expressResult: result
    })
    this.onCancel();
  }

  // 取消Modal
  onCancel = () => {
    this.setState({
      contactVisible: false,
      expressVisible: false,
      rejectCheckVisible: false
    })
  }
  // 已邮寄，寄出包裹邮寄信息，收到包裹信息，回调
  onSuccessExpress = async values => {
    const { expressType, flowId } = this.state;
    this.setState({
      postLoading: true
    })
    try {
      if (!expressType) {
        // 已邮寄
        const { result } = await finishExpressMaterial(flowId, {
          content: expressDescSteps.posted,
          ...values
        })
        this.getPostedPackages();
        this.setState({
          expressVisible: false,
          expressResult: result
        })
      } else {
        // 收到/寄出包裹
        await addExpressPackage(expressType, flowId, values);
        this.setState({
          expressVisible: false
        })
        if (expressType === 'receive') {
          this.getReceivedPackages();
        } else if (expressType === 'post') {
          this.getPostedPackages();
        }
      }
    } catch { }
    this.setState({
      postLoading: false
    })
  }
  // 待审核状态/操作
  renderToCheckStatus = () => {
    const { expressResult } = this.state;
    const { isReportAgent, isAuditor } = this.props;
    if (isAuditor) {
      return;
    }
    if (expressResult.state === 'toCheck') {
      return <span className="status-pending">等待审核</span>
    }
    return isReportAgent ? <Button className="margin-left" size="small" type="primary" onClick={() => this.setState({ contactVisible: true })}>已沟通客户</Button> : null;
  }

  render() {
    const { isAuditor, isReportAgent } = this.props, { flowId, expressVisible, expressResult, handleLoading, recheckLoading, postLoading, rejectCheckVisible, contactVisible, receivedPackageList, postedPackageList, expressType } = this.state;
    const isPosted = expressResult.state === 'posted', currentStep = getStepByStatus(expressResult.state);

    const formProps = {
      flowId,
      onCancel: this.onCancel,
      onSuccess: this.onSuccess
    }

    return (
      <div style={{ overflowY: 'auto', height: '100%' }}>
        <div className="material-express">
          <div className="material-express-l">
            <Card
              size="small"
              title="收到包裹"
              extra={<a onClick={() => this.onShowExpress('receive')} className="iconfont icon-plus"></a>}
            >
              <PackageList list={receivedPackageList} expressType="receive" />
            </Card>
            <Card
              size="small"
              title="寄出包裹"
              extra={isPosted ? <a onClick={() => this.onShowExpress('post')} className="iconfont icon-plus"></a> : null}
            >
              <PackageList list={postedPackageList} />
            </Card>
          </div>
          <div className="material-express-r">
            <Steps
              current={currentStep}
              direction="vertical"
              size="small"
              className="material-express-steps"
              status={isPosted ? 'finish' : 'process'}
            >
              {/* 发起材料邮寄保司 */}
              <Step
                title={
                  <React.Fragment>
                    <div>发起材料邮寄保司</div>
                    {currentStep === 0 && isReportAgent
                      ? <Button
                        size="small"
                        type="primary"
                        loading={handleLoading}
                        onClick={this.handleExpressTask}
                      >
                        发起任务
                      </Button>
                      : currentStep > 0 ? <span className="status-success">已发起</span> : null}
                  </React.Fragment>
                }
                description={currentStep >= 1 ? this.renderRecords('toCheck') : <dl><dt>{expressDescSteps.toCheck}</dt></dl>}
              />
              {/* 单证岗审核材料 */}
              <Step
                title={
                  <React.Fragment>
                    <div>单证岗审核材料</div>
                    {
                      currentStep === 1 ? <div>
                        {/* 所有人员都可见不合格状态 */}
                        {
                          ['returned', 'added'].includes(expressResult.state) ? <span className="status-fail">不合格</span> : null
                        }
                        {/* 非单证岗展示材料合格的审核状态 */}
                        {
                          this.renderToCheckStatus()
                        }
                        {/* 单证审核岗 */}
                        {
                          isAuditor ? <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item key="success" onClick={this.handleApprove}>合格</Menu.Item>
                                <Menu.Item key="fail" onClick={() => this.setState({ rejectCheckVisible: true })}>不合格</Menu.Item>
                              </Menu>
                            }
                            trigger="click"
                          >
                            <Button size="small" type="primary" className="margin-left">提交结论</Button>
                          </Dropdown> : null
                        }
                      </div> : null
                    }
                    {
                      currentStep > 1 ? <span className="status-success">合格</span> : null
                    }
                  </React.Fragment>
                }
                description={currentStep >= 1 && expressResult.state !== 'toCheck' ? this.renderRecords('checkAgent') : <dl><dt>{expressDescSteps.checkAgent}</dt></dl>}
              />
              {/* 材料邮寄保司 */}
              <Step title={<React.Fragment>
                <div>材料已邮寄</div>
                {
                  currentStep === 2 ? <div>
                    {
                      expressResult.state === 'toPost' ? (isAuditor ? <Button size="small" type="primary" onClick={() => this.onShowExpress()}>已邮寄</Button> : <span className="status-pending">等待审核</span>) : null
                    }
                    {
                      isPosted ? <span className="status-success">已邮寄</span> : null
                    }
                  </div> : null
                }
              </React.Fragment>
              } description={currentStep === 2 && isPosted ? this.renderRecords('posted') : <dl><dt>{expressDescSteps.posted}</dt></dl>} />
            </Steps>
          </div>
        </div>
        {/* 提交初审结论 */}
        <Modal visible={rejectCheckVisible} title="提交结论" footer={null} onCancel={this.onCancel} destroyOnClose>
          <CheckForm {...formProps} />
        </Modal>
        {/* 确认沟通客户 */}
        <Modal visible={contactVisible} title="已沟通客户" footer={null} onCancel={this.onCancel} destroyOnClose>
          <ContactForm {...formProps} />
        </Modal>
        {/* 填写邮寄信息 */}
        <Modal visible={expressVisible} title="录入邮寄信息" footer={null} onCancel={this.onCancel} destroyOnClose>
          <ExpressForm loading={postLoading}  onCancel={this.onCancel} onSuccess={this.onSuccessExpress} expressType={expressType} />
        </Modal>
      </div>
    );
  }
}
